import { TFieldProps } from 'types';

import { Links } from '../../../../../links';

export const fields = (
  collectorId: string,
  duplicateOf?: number,
  duplicates?: number[],
  externalId?: number,
): TFieldProps[] => [{
  type: TFieldProps.type.DatePicker,
  name: 'submittedDate',
  label: 'Submitted Date',
  extra: 'Shown in EST',
}, {
  type: TFieldProps.type.Text,
  name: 'collectorRegion',
  label: 'Collector Region',
}, {
  type: TFieldProps.type.Text,
  name: 'referenceCode',
  label: 'Reference Code',
}, {
  type: TFieldProps.type.Text,
  name: 'platform',
  label: 'App Version',
}, {
  type: TFieldProps.type.Text,
  name: 'locale',
  label: 'Locale',
}, {
  type: TFieldProps.type.Link,
  name: 'externalId',
  label: 'External ID',
  hidden: !externalId,
  link: {
    to: `https://app.veryfi.com/inbox/invoices_receipts/${externalId}`,
    name: String(externalId),
    external: true,
  },
}, {
  type: TFieldProps.type.Link,
  name: 'duplicateOf',
  label: 'Duplicate Of',
  hidden: !duplicateOf,
  link: {
    to: `${Links.Snaps}/${duplicateOf}`,
    name: String(duplicateOf),
  },
}, {
  type: TFieldProps.type.Link,
  name: 'collectorId',
  label: 'Collector ID',
  link: {
    to: `${Links.Snaps}?collectorId=${collectorId.replace(/\(.*\)/, '')}`,
    name: collectorId,
  },
}, {
  type: TFieldProps.type.Link,
  name: 'duplicates',
  label: 'Duplicates',
  hidden: !duplicates?.length,
  link: duplicates?.map((duplicate) => ({
    to: `${Links.Snaps}/${duplicate}`,
    name: String(duplicate),
  })),
}];
